module.exports = {
  id: 33,
  name: 'Jumping Jacks',
  categories: ['cardio', 'coordination', 'fullBody'],
  sports: [
    'baseball',
    'basketball',
    'boxing',
    'cricket',
    'dance',
    'football',
    'golf',
    'hockey',
    'lacrosse',
    'martial-arts',
    'gymnastics',
    'rugby',
    'soccer',
    'swimming',
    'tennis',
    'track',
    'volleyball',
  ],
  difficulty: 'beginner',
  skill: 'Cardio',
  points: 10,
  instructions:
    'Jumping jacks time! Jump up and spread your arms and legs out like a star, then bring them back together!',
  timedInstructions: [
    // SETUP
    {
      time: 0,
      text: "This makes you strong and coordinated! Let's get started!",
    },
    {
      time: 3,
      text: '3, 2, 1, GO!',
    },
    // SET 1 - 10 reps
    {
      time: 6,
      text: 'Number 1! Jump up and spread out!',
    },
    {
      time: 8,
      text: 'Bring them back together!',
    },
    {
      time: 10,
      text: 'Number 2! Jump and spread!',
    },
    {
      time: 12,
      text: 'Back together!',
    },
    {
      time: 14,
      text: 'Number 3! Jump up high!',
    },
    {
      time: 16,
      text: 'Bring them back!',
    },
    {
      time: 18,
      text: 'Number 4! Spread your arms and legs!',
    },
    {
      time: 20,
      text: 'Back to center!',
    },
    {
      time: 22,
      text: 'Number 5! Jump like a star!',
    },
    {
      time: 24,
      text: 'Come back together!',
    },
    {
      time: 26,
      text: 'Number 6! Jump and spread!',
    },
    {
      time: 28,
      text: 'Back together!',
    },
    {
      time: 30,
      text: 'Number 7! Jump up high!',
    },
    {
      time: 32,
      text: 'Bring them back!',
    },
    {
      time: 34,
      text: 'Number 8! Spread out wide!',
    },
    {
      time: 36,
      text: 'Back to center!',
    },
    {
      time: 38,
      text: 'Number 9! Jump like a star!',
    },
    {
      time: 40,
      text: 'Come back together!',
    },
    {
      time: 42,
      text: 'Number 10! Last one of this set!',
    },
    {
      time: 44,
      text: 'Back together! Great job!',
    },
    // REST PERIOD 1 - 27 seconds
    {
      time: 47,
      text: 'Take a deep breath in and out.',
    },
    {
      time: 50,
      text: 'Shake out your arms and legs.',
    },
    {
      time: 53,
      text: 'Get ready for round two!',
    },
    {
      time: 56,
      text: 'You are doing amazing!',
    },
    {
      time: 59,
      text: 'Ready for set two?',
    },
    {
      time: 62,
      text: '3, 2, 1, GO!',
    },
    // SET 2 - 10 reps
    {
      time: 65,
      text: 'Number 1! Jump up and spread out!',
    },
    {
      time: 67,
      text: 'Bring them back together!',
    },
    {
      time: 69,
      text: 'Number 2! Jump and spread!',
    },
    {
      time: 71,
      text: 'Back together!',
    },
    {
      time: 73,
      text: 'Number 3! Jump up high!',
    },
    {
      time: 75,
      text: 'Bring them back!',
    },
    {
      time: 77,
      text: 'Number 4! Spread your arms and legs!',
    },
    {
      time: 79,
      text: 'Back to center!',
    },
    {
      time: 81,
      text: 'Number 5! Jump like a star!',
    },
    {
      time: 83,
      text: 'Come back together!',
    },
    {
      time: 85,
      text: 'Number 6! Jump and spread!',
    },
    {
      time: 87,
      text: 'Back together!',
    },
    {
      time: 89,
      text: 'Number 7! Jump up high!',
    },
    {
      time: 91,
      text: 'Bring them back!',
    },
    {
      time: 93,
      text: 'Number 8! Spread out wide!',
    },
    {
      time: 95,
      text: 'Back to center!',
    },
    {
      time: 97,
      text: 'Number 9! Jump like a star!',
    },
    {
      time: 99,
      text: 'Come back together!',
    },
    {
      time: 101,
      text: 'Number 10! Last one of this set!',
    },
    {
      time: 103,
      text: 'Back together! Great job!',
    },
    // REST PERIOD 2 - 27 seconds
    {
      time: 106,
      text: 'Take a deep breath in and out.',
    },
    {
      time: 109,
      text: 'Shake out your arms and legs.',
    },
    {
      time: 112,
      text: 'Get ready for round three!',
    },
    {
      time: 115,
      text: 'You are doing amazing!',
    },
    {
      time: 118,
      text: 'Ready for set three?',
    },
    {
      time: 121,
      text: '3, 2, 1, GO!',
    },
    // SET 3 - 10 reps
    {
      time: 124,
      text: 'Number 1! Jump up and spread out!',
    },
    {
      time: 126,
      text: 'Bring them back together!',
    },
    {
      time: 128,
      text: 'Number 2! Jump and spread!',
    },
    {
      time: 130,
      text: 'Back together!',
    },
    {
      time: 132,
      text: 'Number 3! Jump up high!',
    },
    {
      time: 134,
      text: 'Bring them back!',
    },
    {
      time: 136,
      text: 'Number 4! Spread your arms and legs!',
    },
    {
      time: 138,
      text: 'Back to center!',
    },
    {
      time: 140,
      text: 'Number 5! Jump like a star!',
    },
    {
      time: 142,
      text: 'Come back together!',
    },
    {
      time: 144,
      text: 'Number 6! Jump and spread!',
    },
    {
      time: 146,
      text: 'Back together!',
    },
    {
      time: 148,
      text: 'Number 7! Jump up high!',
    },
    {
      time: 150,
      text: 'Bring them back!',
    },
    {
      time: 152,
      text: 'Number 8! Spread out wide!',
    },
    {
      time: 154,
      text: 'Back to center!',
    },
    {
      time: 156,
      text: 'Number 9! Jump like a star!',
    },
    {
      time: 158,
      text: 'Come back together!',
    },
    {
      time: 160,
      text: 'Number 10! Last one of this set!',
    },
    {
      time: 162,
      text: 'Back together! Great job!',
    },
    // REST PERIOD 3 - 27 seconds
    {
      time: 165,
      text: 'Take a deep breath in and out.',
    },
    {
      time: 168,
      text: 'Shake out your arms and legs.',
    },
    {
      time: 171,
      text: 'Get ready for the final round!',
    },
    {
      time: 174,
      text: 'You are doing amazing!',
    },
    {
      time: 177,
      text: 'Ready for the final set?',
    },
    {
      time: 180,
      text: '3, 2, 1, GO!',
    },
    // SET 4 - 10 reps
    {
      time: 183,
      text: 'Number 1! Jump up and spread out!',
    },
    {
      time: 185,
      text: 'Bring them back together!',
    },
    {
      time: 187,
      text: 'Number 2! Jump and spread!',
    },
    {
      time: 189,
      text: 'Back together!',
    },
    {
      time: 191,
      text: 'Number 3! Jump up high!',
    },
    {
      time: 193,
      text: 'Bring them back!',
    },
    {
      time: 195,
      text: 'Number 4! Spread your arms and legs!',
    },
    {
      time: 197,
      text: 'Back to center!',
    },
    {
      time: 199,
      text: 'Number 5! Jump like a star!',
    },
    {
      time: 201,
      text: 'Come back together!',
    },
    {
      time: 203,
      text: 'Number 6! Jump and spread!',
    },
    {
      time: 205,
      text: 'Back together!',
    },
    {
      time: 207,
      text: 'Number 7! Jump up high!',
    },
    {
      time: 209,
      text: 'Bring them back!',
    },
    {
      time: 211,
      text: 'Number 8! Spread out wide!',
    },
    {
      time: 213,
      text: 'Back to center!',
    },
    {
      time: 215,
      text: 'Number 9! Jump like a star!',
    },
    {
      time: 217,
      text: 'Come back together!',
    },
    {
      time: 219,
      text: 'Number 10! Last one ever!',
    },
    {
      time: 221,
      text: 'Back together! You are done!',
    },
    // COMPLETION
    {
      time: 224,
      text: 'Amazing work! You just did 40 jumping jacks!',
    },
    {
      time: 227,
      text: 'You are building incredible coordination!',
    },
    {
      time: 230,
      text: 'Great job, champion!',
    },
  ],
};
